"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromX64_BN = exports.fromX64_Decimal = exports.fromX64 = exports.toX64 = exports.toX64_Decimal = exports.toX64_BN = void 0;
const anchor_1 = require("@project-serum/anchor");
const decimal_js_1 = __importDefault(require("decimal.js"));
function toX64_BN(num) {
    return num.mul(new anchor_1.BN(2).pow(new anchor_1.BN(64)));
}
exports.toX64_BN = toX64_BN;
function toX64_Decimal(num) {
    return num.mul(decimal_js_1.default.pow(2, 64));
}
exports.toX64_Decimal = toX64_Decimal;
function toX64(num) {
    return new anchor_1.BN(num.mul(decimal_js_1.default.pow(2, 64)).floor().toFixed());
}
exports.toX64 = toX64;
function fromX64(num) {
    return new decimal_js_1.default(num.toString()).mul(decimal_js_1.default.pow(2, -64));
}
exports.fromX64 = fromX64;
function fromX64_Decimal(num) {
    return num.mul(decimal_js_1.default.pow(2, -64));
}
exports.fromX64_Decimal = fromX64_Decimal;
function fromX64_BN(num) {
    return num.div(new anchor_1.BN(2).pow(new anchor_1.BN(64)));
}
exports.fromX64_BN = fromX64_BN;
